import styled from 'styled-components'

interface IStatusCardLegacyCollapsibleToggleStyledProps {}

export const StatusCardLegacyCollapsibleToggleStyled = styled.div<IStatusCardLegacyCollapsibleToggleStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
